import angular from 'angular'
import moment from 'moment-timezone'

angular
  .module('admin.user_segmentation.manager', [])
  .controller('UserSegmentationManagerCtrl', UserSegmentationManagerCtrl)

/** @ngInject */
function UserSegmentationManagerCtrl(
  $scope,
  $rootScope,
  $state,
  $stateParams,
  $q,
  $timeout,
  UserCache,
  EventService,
  UserSegmentationService,
  CoinProductService,
  CampaignsService,
  PromoService,
  UsersService,
  CouponsService,
) {
  var vm = this
  var cache = UserCache.getObject()
  var userId = cache.user.id
  vm.currentID = $stateParams.id

  $('#e15').select2('data', [])

  vm.listLinked = []
  vm.coinProducts = []
  vm.channels = []
  vm.sets = []
  vm.users = []
  vm.listUsers = []
  vm.coupons = []
  vm.inputIds = ''
  vm.isCoinProduct = false
  vm.isProductPrice = false
  vm.isTotalSpentUser = false
  vm.isTotalSpentUser2 = false
  vm.isTotalPurchaseUser = false
  vm.isTypeDate = 'absolute'
  vm.isOpen = false
  vm.isOpen1 = false
  vm.isGroupButton1 = false
  vm.durMin = 2
  vm.durMax = 2
  vm.waitChannel = true
  vm.waitSet = true
  vm.waitCampaign = true
  vm.orFlow = false

  vm.options = [
    {
      id: 1,
      name: 'Username',
    },
    {
      id: 2,
      name: 'Email',
    },
    {
      id: 3,
      name: 'ID',
    },
  ]
  vm.option = vm.options[0].id

  function isNumber(n) {
    return typeof n == 'number' && !isNaN(n) && isFinite(n)
  }

  function reloadPagination() {
    vm.totalUsers = 0
    vm.oldPage = 0
    vm.usersPerPage = 25
    vm.currentPage = 25
    vm.first = true
    vm.totalItems = 0
    vm.pagination = {
      current: 1,
    }
  }

  reloadPagination()

  function reset() {
    vm.inputIds = ''
    vm.isCoinProduct = false
    vm.isProductPrice = false
    vm.isTotalSpentUser = false
    vm.isTotalSpentUser2 = false
    vm.isTotalPurchaseUser = false
    vm.isTypeDate = 'absolute'
    vm.isOpen = false
    vm.isOpen1 = false
    vm.isGroupButton1 = false
    vm.durMin = 2
    vm.durMax = 2
    vm.waitChannel = true
    vm.waitSet = true
    vm.waitCampaign = true
    vm.channelId = null
    vm.waitChannel = true
    vm.checkSetList = false
    vm.checkScore = false
    vm.checkCompletation = false
    vm.checkValue = false
    vm.isSetList = false
    vm.isBundleList = false
    vm.isPurchaseCount = false
    vm.isSpentBundle = false
    vm.isSpentCashBundle = false
    vm.checkProductPrice = false
    vm.checkTotalSpentUser = false
    vm.checkTotalPurchaseUser = false
    vm.checkBundleList = false
    vm.checkIncludeFree = false
    vm.checkPurchaseCount = false
    vm.checkSpentBundle = false
    vm.checkSpentCashBundle = false
    vm.campaignId = null
    vm.orFlow = false
    vm.date1 = null
    vm.date2 = null
    vm.collectibleByChannelId = null
    vm.collectibleBySetId = null
    vm.collectibleByCollectibleId = null
    vm.collectibleByAll = false
    vm.collectibleByBatchIds = false
    $('#e8').select2('data', [])
    $('#e9').select2('data', [])
    $('#shinySelect').select2('data', [])

    vm.model = {
      //default
      t: '',
      txt: '',
      k: 18,
      rule: {},
      rulet: '',
      'id-cb': userId,

      //coin product
      cp: {},
      'pr-k': {},
      pp: {},
      tsu: {},
      tpu: {},
      'dur-min': 0,
      'dur-max': 0,
      store: [],

      //sets
      sets: {},
      'r-val-min': undefined,
      'r-val-max': undefined,
      'r-comp-min': undefined,
      'r-comp-max': undefined,

      //bundles
      bundles: {},
      'cbp-min': undefined,
      'cbp-max': undefined,
      'spent-min': undefined,
      'spent-max': undefined,
      'spent-min-cash': undefined,
      'spent-max-cash': undefined,
      'inc-free': false,

      // promo
      'id-promo': undefined,

      //user
      'id-u': [],

      //A/B Testing
      'c-cohort': undefined,
      ctm: undefined,

      //andSegment, xorSegment, notSegment, excludeSegment
      'id-seg': [],
      //excludeSegment
      'id-sseg': [],

      //listing
      'lc-min': undefined,
      'lc-max': undefined,
      'sc-min': undefined,
      'sc-max': undefined,
      'sa-min': undefined,
      'sa-max': undefined,
      'id-ch': undefined,
      'id-s': undefined,

      //fyber
      'ce-min': undefined,
      'ce-max': undefined,
      'ec-min': undefined,
      'ec-max': undefined,

      //wallet & claim
      'c-min': undefined,
      'c-max': undefined,

      //claim
      'cl-min': undefined,
      'cl-max': undefined,

      // collection size
      'cpo-min': undefined,
      'cpo-max': undefined,
      'cqo-min': undefined,
      'cqo-max': undefined,

      // own collectible ids
      'id-q': [],
      all: undefined,

      // collection value
      'val-min': undefined,
      'val-max': undefined,

      //region
      lcs: undefined,

      //language
      lang: undefined,
      comm: undefined,

      //coupon
      'id-cpn': undefined,

      // user notification preference
      unp: {
        k: undefined,
        met: undefined,
        enabled: undefined,
      },

      sw: {
        'id-s': undefined,
        all: false,
      },
      chw: {
        'id-ch': undefined,
        all: false,
      },
      dhw: {
        'id-dr': undefined,
        all: false,
      },

      usignin: {
        'cc-min': undefined,
        'cc-max': undefined,
        days: false,
        m: undefined,
        all: false,
      },
      burn: {
        'cc-min': undefined,
        'cc-max': undefined,
        'id-s': undefined,
        'id-q': undefined,
        'id-shiny': undefined,
        all: false,
      },
      channel: {
        'id-ch': undefined,
        'k-album': undefined,
        'r-val-min': undefined,
        'r-val-max': undefined,
      },
      user_status: {
        'kyc-st': undefined,
        verified: undefined,
        'email-verified': undefined,
        '2fa-enabled': undefined,
        '2fa-type': undefined,
      },
    }

    vm.modelOr = {
      k: 20,
    }
  }

  vm.twoFactorTypes = [
    { id: 1, name: 'SMS' },
    { id: 2, name: 'Call' },
    { id: 3, name: 'Email' },
    { id: 4, name: 'TOTP' },
  ]

  vm.userVerifieds = [
    { id: 0, name: 'Not Verified' },
    { id: 1, name: 'Verified' },
    { id: 2, name: 'Grandfathered' },
    { id: 3, name: 'Registration Incomplete' },
  ]

  vm.albumTypes = [
    {
      id: 'channel',
      name: 'Channel',
    },
    {
      id: 'sets',
      name: 'Sets',
    },
    {
      id: 'awards',
      name: 'Awards',
    },
  ]

  vm.notificationMethod = [
    {
      id: 1,
      name: 'Email',
    },
    {
      id: 2,
      name: 'Push',
    },
    {
      id: 3,
      name: 'In App',
    },
    {
      id: 4,
      name: 'Inbox',
    },
    {
      id: 5,
      name: 'SMS',
    },
  ]

  vm.notificationType = [
    {
      id: 4,
      name: 'At Mention',
      group: 'My Connections',
    },
    {
      id: 5,
      name: 'New Follower',
      group: 'My Connections',
    },
    {
      id: 6,
      name: 'Storyboard Liked',
      group: 'My Connections',
    },
    {
      id: 9,
      name: 'Chat Message',
      group: 'My Connections',
    },
    {
      id: 1,
      name: 'Listing Sold',
      group: 'My Collection Activity',
    },
    {
      id: 3,
      name: 'Print Received',
      group: 'My Collection Activity',
    },
    {
      id: 7,
      name: 'Wishlist Item Listed',
      group: 'My Collection Activity',
    },
    {
      id: 8,
      name: 'Wishlist Inquiry',
      group: 'My Collection Activity',
    },
    {
      id: 13,
      name: 'This Week on Collectible',
      group: 'Marketing',
    },
    {
      id: 14,
      name: 'Collectible Newsletter',
      group: 'Marketing',
    },
    {
      id: 20,
      name: 'Brand Revival',
      group: 'Marketing',
    },
    {
      id: 15,
      name: 'Free Pack',
      group: 'Marketing',
    },
    {
      id: 16,
      name: 'Flash Pack',
      group: 'Marketing',
    },
    {
      id: 44,
      name: 'All Collections',
      group: 'Drops',
    },
    {
      id: 45,
      name: 'Collection Recommendations',
      group: 'Drops',
    },
    {
      id: 46,
      name: 'Collections I Own',
      group: 'Drops',
    },
  ]

  vm.notificationType = _.orderBy(vm.notificationType, ['group', 'name'], ['asc', 'asc'])

  vm.loginMethods = [
    {
      id: 1,
      name: 'Credentials',
    },
    {
      id: 2,
      name: 'Google',
    },
    {
      id: 3,
      name: 'Facebook',
    },
    {
      id: 4,
      name: 'Apple',
    },
    {
      id: 5,
      name: 'Crypto',
    },
  ]

  vm.types = [
    {
      id: 18,
      t: 'Collectible Ownership - Owns Collectibles',
      type: 'Chase Rules',
    },
    {
      id: 3,
      t: "Set - User's activity in a set",
      type: 'Chase Rules',
    },
    {
      id: 4,
      t: "Channel - User's activity in a channel",
      type: 'Chase Rules',
    },
    {
      id: 6,
      t: 'User - User fits specific attributes or has completed certain actions',
      type: 'User Criteria Rules',
    },
    {
      id: 1,
      t: "Product / Deposit - User's purchase history",
      type: 'User Activity Rules',
    },
    {
      id: 2,
      t: "Collectible Bundle - User's bundle purchase history",
      type: 'Chase Rules',
    },
    {
      id: 5,
      t: 'Promo - Promos codes',
      type: 'User Activity Rules',
    },
    {
      id: 5.1,
      t: 'Promo Affiliate - Promos codes',
      type: 'User Activity Rules',
    },
    {
      id: 7,
      t: 'A/B Testing - Two-sample hypothesis testing',
      type: 'User Criteria Rules',
    },
    {
      id: 8,
      t: 'And Segment - Intersection of two segments',
      type: 'Logic Rules',
    },
    {
      id: 9,
      t: 'Xor Segment - Intersection of two segments',
      type: 'Logic Rules',
    },
    {
      id: 20,
      t: 'Or Segment - Intersection of two segments',
      type: 'Logic Rules',
    },
    {
      id: 10,
      t: 'Not Segment - Intersection of one segment minimum',
      type: 'Logic Rules',
    },
    {
      id: 11,
      t: 'Exclude Segment - Subtract one segment from another',
      type: 'Logic Rules',
    },
    {
      id: 13,
      t: 'Listing - Listing Sales or Purchases',
      type: 'User Activity Rules',
    },
    {
      id: 14,
      t: "Fyber - User's Fyber activity",
      type: 'Deprecated',
    },
    {
      id: 15,
      t: 'Coin Wallet - Coin Wallet activity',
      type: 'Deprecated',
    },
    {
      id: 16,
      t: 'Coin Claim - Coin Claim activity',
      type: 'Deprecated',
    },
    {
      id: 17,
      t: 'Collection Size - Collection Size activity',
      type: 'User Criteria Rules',
    },
    {
      id: 19,
      t: 'Collection Value - Collection Value activity',
      type: 'Deprecated',
    },
    {
      id: 21,
      t: 'Region - Region activity',
      type: 'User Criteria Rules',
    },
    {
      id: 22,
      t: 'Language - Language activity',
      type: 'User Criteria Rules',
    },
    {
      id: 23,
      t: 'Coupon - Coupon activity',
      type: 'User Activity Rules',
    },
    {
      id: 24,
      t: 'User Notification Preference',
      type: 'User Criteria Rules',
    },
    {
      id: 25,
      t: "Set Waitlist - User's activity in a set waitlist",
      type: 'User Criteria Rules',
    },
    {
      id: 26,
      t: "User Sign-in - User's login activity",
      type: 'User Activity Rules',
    },
    {
      id: 27,
      t: "Burn - User's burn activity",
      type: 'User Activity Rules',
    },
    {
      id: 28,
      t: "Channel Waitlist - User's activity in a channel waitlist",
      type: 'User Criteria Rules',
    },
    {
      id: 29,
      t: "Drop Waitlist - User's activity in a drop waitlist",
      type: 'User Criteria Rules',
    },
    {
      id: 30,
      t: "User Status - User's activity in a user status",
      type: 'User Criteria Rules',
    },
  ]

  vm.typesOr = [
    {
      id: 8,
      t: 'And Segment - Intersection of two segments',
    },
    {
      id: 9,
      t: 'Xor Segment - Intersection of two segments',
    },
    {
      id: 20,
      t: 'Or Segment - Intersection of two segments',
    },
    {
      id: 10,
      t: 'Not Segment - Intersection of one segment minimum',
    },
  ]

  vm.stores = [
    {
      id: 1,
      name: 'App Store',
    },
    {
      id: 2,
      name: 'Play Store',
    },
    {
      id: 3,
      name: 'Stripe',
    },
  ]

  reset()

  var isDate = function (date) {
    return new Date(date) !== 'Invalid Date' && !isNaN(new Date(date))
  }

  var whichPage = window.location.pathname
  vm.isCheckListPage = whichPage.indexOf('checklist') !== -1

  // checklist
  $('#modalSegmentation').on('shown.bs.modal', function () {
    reset()
    var segmentID = parseInt(localStorage.getItem('checklist_segment_id'))
    if (segmentID && segmentID !== 0) {
      vm.currentID = segmentID
      EventService.listChannels().then(function (result) {
        vm.channels = result.results
        CampaignsService.listGeneral().then(function (result2) {
          vm.campaigns = result2.results
          load()
        })
        CampaignsService.listAffiliate().then(function (result2) {
          vm.campaignsAffiliate = result2.results
        })
      })
    } else {
      vm.currentID = null
      EventService.listChannels().then(function (result) {
        vm.channels = result.results
      })
      CampaignsService.listGeneral().then(function (result) {
        vm.campaigns = result.results
      })
      CampaignsService.listAffiliate().then(function (result2) {
        vm.campaignsAffiliate = result2.results
      })
    }
  })

  if (vm.isCheckListPage) {
    reset()
    var segmentID = parseInt(localStorage.getItem('checklist_segment_id'))
    if (segmentID && segmentID !== 0) {
      vm.currentID = segmentID
      EventService.listChannels().then(function (result) {
        vm.channels = result.results
        CampaignsService.listGeneral().then(function (result2) {
          vm.campaigns = result2.results
          load()
        })
        CampaignsService.listAffiliate().then(function (result2) {
          vm.campaignsAffiliate = result2.results
        })
      })
    } else {
      vm.currentID = null
      EventService.listChannels().then(function (result) {
        vm.channels = result.results
      })
      CampaignsService.listGeneral().then(function (result) {
        vm.campaigns = result.results
      })
      CampaignsService.listAffiliate().then(function (result2) {
        vm.campaignsAffiliate = result2.results
      })
    }
  } else {
    if (vm.currentID !== '0' && vm.currentID !== null && vm.currentID !== undefined) {
      EventService.listChannels().then(function (result) {
        vm.channels = result.results
        CampaignsService.listGeneral().then(function (result2) {
          vm.campaigns = result2.results
          load()
        })
        CampaignsService.listAffiliate().then(function (result2) {
          vm.campaignsAffiliate = result2.results
        })
      })
    } else {
      EventService.listChannels().then(function (result) {
        vm.channels = result.results
      })
      CampaignsService.listGeneral().then(function (result) {
        vm.campaigns = result.results
      })
      CampaignsService.listAffiliate().then(function (result2) {
        vm.campaignsAffiliate = result2.results
      })
    }
  }

  function loadUsers(pageNumber) {
    if (vm.option !== 3) {
      if (
        vm.search === undefined ||
        vm.search === null ||
        vm.search === '' ||
        vm.search.length < 3
      ) {
        return
      }
    } else {
      if (vm.search === undefined || vm.search === null || vm.search === '') {
        return
      }
    }

    if (pageNumber === 1) {
      vm.pagination.current = 1
    }
    if (!vm.first) {
      vm.currentPage = pageNumber * 25
      vm.oldPage = vm.currentPage - 25
    } else {
      vm.first = false
    }
    vm.items = []
    if (vm.option === 1) {
      UsersService.search(vm.search, '', vm.oldPage, 25).then(function (result) {
        if (vm.totalItems === 0) {
          vm.totalItems = result.ct
        }
        vm.users = result.results
        vm.users.map(function (item) {
          item.added = false
        })
      })
    } else if (vm.option === 2) {
      UsersService.searchEmail(vm.search, '', vm.oldPage, 25).then(function (result) {
        if (vm.totalItems === 0) {
          vm.totalItems = result.ct
        }
        vm.users = result.results
        vm.users.map(function (item) {
          item.added = false
        })
      })
    } else {
      UsersService.get(vm.search).then(function (result) {
        if (vm.totalItems === 0) {
          vm.totalItems = 1
        }
        vm.users = [result.results]
        vm.users.map(function (item) {
          item.added = false
        })
      })
    }
  }

  vm.pageChanged = function (newPage) {
    loadUsers(newPage)
  }

  vm.searchUsers = function () {
    reloadPagination()
    loadUsers(1)
  }

  vm.addUser = function (item) {
    item.added = true
    var exist = _.find(vm.listUsers, { id: item.id })
    if (exist !== null) {
      vm.listUsers.push(item)
    }
  }

  vm.removeUser = function (item) {
    item.added = false
    vm.listUsers.remove(item)
  }

  function load() {
    UserSegmentationService.get(vm.currentID).then(function (result) {
      var model = result.results
      var rule = JSON.parse(model.rule)
      vm.model.t = model.t
      vm.model.txt = model.txt
      vm.model.k = model.k
      vm.model['id-cb'] = model['id-cb']

      var rulet = ''
      if (vm.model.k === 1) {
        //load inputs
        if (rule['id-p'] !== undefined) {
          vm.isCoinProduct = true
          vm.model.cp.value = rule['id-p']
          vm.checkCoinProduct = true

          if (rule.all) {
            vm.isGroupButton1 = true
          }
        } else {
          vm.isCoinProduct = false
          vm.isProductPrice = false
          vm.checkProductPrice = false
        }

        if (rule['price-min'] !== undefined) {
          vm.isProductPrice = true
          vm.checkProductPrice = true
          vm.model.pp.min = rule['price-min']
        }
        if (rule['price-max'] !== undefined) {
          vm.isProductPrice = true
          vm.checkProductPrice = true
          vm.model.pp.max = rule['price-max']
        }

        if (rule['spent-min'] !== undefined) {
          vm.checkTotalSpentUser = true
          vm.isTotalSpentUser = true
          vm.model.tsu.min = rule['spent-min']
        }
        if (rule['spent-max'] !== undefined) {
          vm.checkTotalSpentUser = true
          vm.isTotalSpentUser = true
          vm.model.tsu.max = rule['spent-max']
        }

        if (rule['cp-min'] !== undefined) {
          vm.checkTotalPurchaseUser = true
          vm.isTotalPurchaseUser = true
          vm.model.tpu.min = rule['cp-min']
        }
        if (rule['cp-max'] !== undefined) {
          vm.checkTotalPurchaseUser = true
          vm.isTotalPurchaseUser = true
          vm.model.tpu.max = rule['cp-max']
        }
        if (rule['pr-k'] === 4) {
          vm.model['pr-k'] = rule['pr-k']
          vm.checkCoinProductCashDeposit = true
        }
        if (rule['store']) {
          vm.model.store = rule['store']
        }
        if (rule['pr-k'] === 4) {
          // create string rule
          rulet += 'Cash Deposit - '
        } else {
          rulet += 'Coin Products - '
        }
        if (rule.all && rule['id-p'] !== undefined) {
          var idsConcat = ''
          rule['id-p'].map(function (item) {
            idsConcat += item + ','
          })
          rulet += idsConcat + ' - '
        } else if (!rule.all && rule['id-p'] !== undefined) {
          var idsConcat = ''
          rule['id-p'].map(function (item) {
            idsConcat += item + ','
          })
          rulet += idsConcat + ' - '
        }

        if (rule['id-p'] === undefined) {
          if (rule['price-min'] !== undefined) {
            rulet += 'Price min $' + rule['price-min'] + ', '
          }
          if (rule['price-max'] !== undefined) {
            rulet += 'Price max $' + rule['price-max'] + ' - '
          }
        }

        if (rule['spent-min'] !== undefined) {
          rulet += 'Spent min $' + rule['spent-min'] + ', '
        }
        if (rule['spent-max'] !== undefined) {
          rulet += 'Spent max $' + rule['spent-max'] + ' - '
        }

        if (rule['cp-min'] !== undefined) {
          rulet += 'Purchased min ' + rule['cp-min'] + ', '
        }
        if (rule['cp-max'] !== undefined) {
          rulet += 'Purchased max ' + rule['cp-max'] + ' - '
        }
      } else if (vm.model.k === 2) {
        //load inputs
        if (rule['id-b'] !== undefined) {
          var ids = rule['id-b'].join(',')
          UserSegmentationService.listBundleByIds(ids).then(function (result) {
            var bundles = result.results
            vm.isBundleList = true
            vm.model.bundles.value = rule['id-b']
            $('#e8').select2('data', bundles)
            vm.checkBundleList = true

            if (rule.all) {
              vm.isGroupButton1 = true
            }
          })
        } else {
          if (rule.all) {
            vm.isGroupButton1 = true
          }
          vm.checkIncludeFree = true
        }

        if (rule['id-ch']) {
          vm.channelId = rule['id-ch']
        }
        if (rule['id-s']) {
          UserSegmentationService.listSetsByID(parseInt(rule['id-s'])).then(function (result) {
            $('#setSelect').select2('data', result.results[0])
          })
        }

        // create string rule
        rulet += 'Collectible Bundles - '

        if (rule.all && rule['id-b'] !== undefined) {
          var idsConcat = ''
          rule['id-b'].map(function (item) {
            idsConcat += item + ','
          })
          rulet += idsConcat + ' - '
        } else if (!rule.all && rule['id-b'] !== undefined) {
          var idsConcat = ''
          rule['id-b'].map(function (item) {
            idsConcat += item + ','
          })
          rulet += idsConcat + ' - '
        }

        if (rule['cbp-min'] !== undefined) {
          rulet += 'Purchase count min ' + rule['cbp-min'] + ', '

          vm.checkPurchaseCount = true
          vm.isPurchaseCount = true
          vm.model['cbp-min'] = rule['cbp-min']
        }
        if (rule['cbp-max'] !== undefined) {
          rulet += 'Purchase count max ' + rule['cbp-max'] + ' - '

          vm.checkPurchaseCount = true
          vm.isPurchaseCount = true
          vm.model['cbp-max'] = rule['cbp-max']
        }

        if (rule['spent-min'] !== undefined) {
          rulet += 'Total spent min ' + rule['spent-min'] + ', '

          vm.checkSpentBundle = true
          vm.isSpentBundle = true
          vm.model['spent-min'] = rule['spent-min']
        }
        if (rule['spent-max'] !== undefined) {
          rulet += 'Total spent max ' + rule['spent-max'] + ' - '

          vm.checkSpentBundle = true
          vm.isSpentBundle = true
          vm.model['spent-max'] = rule['spent-max']
        }

        if (rule['spent-min-cash'] !== undefined) {
          rulet += 'Total spent min cash ' + rule['spent-min-cash'] + ', '

          vm.checkSpentCashBundle = true
          vm.isSpentCashBundle = true
          vm.model['spent-min-cash'] = rule['spent-min-cash']
        }
        if (rule['spent-max-cash'] !== undefined) {
          rulet += 'Total spent max cash ' + rule['spent-max-cash'] + ' - '

          vm.checkSpentCashBundle = true
          vm.isSpentCashBundle = true
          vm.model['spent-max-cash'] = rule['spent-max-cash']
        }

        if (rule['inc-free'] !== undefined) {
          rulet += 'Include free: yes -'
        }
      } else if (vm.model.k === 3) {
        //load inputs
        if (rule['id-s'] !== undefined) {
          UserSegmentationService.getSet(rule['id-s'][0]).then(function (result) {
            UserSegmentationService.listSetsByID(rule['id-s'].join()).then(function (resSets) {
              vm.sets = resSets.results
              var set = result.results
              var channel = _.find(vm.channels, { id: set['id-ch'] })
              vm.channelId = channel.id

              vm.isSetList = true
              vm.model.sets.value = rule['id-s']
              vm.isSetList = true

              if (rule.all) {
                vm.isGroupButton1 = true
              }
            })
          })
        } else if (rule['id-ch'] !== undefined) {
          var channel = _.find(vm.channels, { id: rule['id-ch'] })
          vm.channelId = channel.id
        }

        // create string rule
        rulet += 'Sets - '

        if (rule.all && rule['id-s'] !== undefined) {
          var idsConcat = ''
          rule['id-s'].map(function (item) {
            idsConcat += item + ','
          })
          rulet += idsConcat + ' - '
        } else if (!rule.all && rule['id-s'] !== undefined) {
          var idsConcat = ''
          rule['id-s'].map(function (item) {
            idsConcat += item + ','
          })
          rulet += idsConcat + ' - '
        }

        if (rule['r-val-min'] !== undefined) {
          rulet += 'Value Rank min ' + rule['r-val-min'] + ', '

          vm.checkValue = true
          vm.isTotalSpentUser2 = true
          vm.model['r-val-min'] = rule['r-val-min']
        }
        if (rule['r-val-max'] !== undefined) {
          rulet += 'Value Rank max ' + rule['r-val-max'] + ' - '

          vm.checkValue = true
          vm.isTotalSpentUser2 = true
          vm.model['r-val-max'] = rule['r-val-max']
        }

        if (rule['r-comp-min'] !== undefined) {
          rulet += 'Comp Rank min ' + rule['r-comp-min'] + ', '

          vm.checkCompletation = true
          vm.isTotalSpentUser = true
          vm.model['r-comp-min'] = rule['r-comp-min']
        }
        if (rule['r-comp-max'] !== undefined) {
          rulet += 'CompRank max ' + rule['r-comp-max'] + ' - '

          vm.checkCompletation = true
          vm.isTotalSpentUser = true
          vm.model['r-comp-max'] = rule['r-comp-max']
        }
      } else if (vm.model.k === 4) {
        rulet += 'Channels - '

        if (rule['id-ch'] !== undefined) {
          var channel = _.find(vm.channels, { id: rule['id-ch'] })
          vm.channelId = channel.id
          rulet += rule['id-ch'] + ' - '
        }

        if (rule['k-album'] !== undefined) {
          vm.model.channel['k-album'] = rule['k-album']
          rulet += 'Album Type - ' + vm.model['k-album'] + ', '
        }

        if (rule['r-val-min'] !== undefined) {
          rulet += 'Value Rank min ' + rule['r-val-min'] + ', '
          vm.model.channel['r-val-min'] = rule['r-val-min']
        }
        if (rule['r-val-max'] !== undefined) {
          rulet += 'Value Rank max ' + rule['r-val-max']
          vm.model.channel['r-val-max'] = rule['r-val-max']
        }
      } else if (vm.model.k === 5 || vm.model.k === 5.1) {
        if (rule['id-promo'] !== undefined && rule['id-pc'] !== undefined) {
          var campaignFind
          campaignFind = _.find(vm.campaigns, { id: rule['id-pc'] })
          if (!campaignFind) {
            campaignFind = _.find(vm.campaignsAffiliate, {
              id: rule['id-pc'],
            })
          }
          vm.campaignId = campaignFind.id
          if (campaignFind.k === 1) {
            vm.model.k = 5.1
          }
          PromoService.list(vm.campaignId).then(function (response) {
            vm.promos = response.results
            vm.waitCampaign = false
            vm.model['id-promo'] = rule['id-promo']
          })
        }

        rulet += 'Promo ID ' + rule['id-promo']
      } else if (vm.model.k === 6) {
        rulet += 'Users ID ' + rule['id-u']
        UserSegmentationService.listUserBySegmentation(vm.currentID).then(function (result) {
          vm.listUsers = result.results
        })
      } else if (vm.model.k === 7) {
        if (rule['c-cohort'] !== undefined) {
          vm.model['c-cohort'] = rule['c-cohort']
          rulet += 'Cohort Count - ' + vm.model['c-cohort'] + ', '
        }
        if (rule.ctm !== undefined) {
          vm.model.ctm = rule.ctm
          rulet += 'Cohort To Match - ' + vm.model.ctm
        }
      } else if (vm.model.k === 8) {
        if (rule['id-seg'] !== undefined) {
          UserSegmentationService.getByIds(rule['id-seg']).then(function (result) {
            vm.model['id-seg'] = rule['id-seg']
            $('#e15').select2('data', result.results)
            var idsConcat = ''
            vm.model['id-seg'].map(function (item) {
              idsConcat += item + ','
            })
            rulet += 'And Segment IDs - ' + idsConcat
          })
        }
      } else if (vm.model.k === 9) {
        if (rule['id-seg'] !== undefined) {
          UserSegmentationService.getByIds(rule['id-seg']).then(function (result) {
            vm.model['id-seg'] = rule['id-seg']
            $('#e15').select2('data', result.results)
            $('#e15').select2('data', rule['id-seg'])
            var idsConcat = ''
            vm.model['id-seg'].map(function (item) {
              idsConcat += item + ','
            })
            rulet += 'Xor Segment IDs - ' + idsConcat
          })
        }
      } else if (vm.model.k === 10) {
        if (rule['id-seg'] !== undefined) {
          UserSegmentationService.getByIds(rule['id-seg']).then(function (result) {
            vm.model['id-seg'] = rule['id-seg']
            $('#e15').select2('data', result.results)
            var idsConcat = ''
            vm.model['id-seg'].map(function (item) {
              idsConcat += item + ','
            })
            rulet += 'Not Segment IDs - ' + idsConcat
          })
        }
      } else if (vm.model.k === 11) {
        if (rule['id-seg'] !== undefined) {
          UserSegmentationService.getByIds(rule['id-seg']).then(function (result) {
            vm.model['id-seg'] = rule['id-seg']
            $('#e15').select2('data', result.results)
            var idsConcat = ''
            vm.model['id-seg'].map(function (item) {
              idsConcat += item + ','
            })
            rulet += 'Exclude Segment IDs - ' + idsConcat
          })
        }
        if (rule['id-sseg'] !== undefined) {
          vm.model['id-sseg'] = rule['id-sseg']
          rulet += 'Starting Segment ID - ' + rule['id-sseg'] + ', '
        }
      } else if (vm.model.k === 13) {
        if (rule['lc-min']) {
          vm.model['lc-min'] = rule['lc-min']
        }
        if (rule['lc-max']) {
          vm.model['lc-max'] = rule['lc-max']
        }
        if (rule['sc-min']) {
          vm.model['sc-min'] = rule['sc-min']
        }
        if (rule['sc-max']) {
          vm.model['sc-max'] = rule['sc-max']
        }
        if (rule['sa-min']) {
          vm.model['sa-min'] = rule['sa-min']
        }
        if (rule['sa-max']) {
          vm.model['sa-max'] = rule['sa-max']
        }
        if (rule['id-ch']) {
          vm.model['id-ch'] = rule['id-ch'][0]
          vm.channelId = vm.model['id-ch']
        }
        if (rule['id-s']) {
          vm.model['id-s'] = rule['id-s'][0]
          vm.setId2 = vm.model['id-s']
        }
        if (rule['pur'] !== undefined) {
          vm.model['pur'] = rule['pur']
          if (vm.model['pur']) {
            vm.listingPurchase = true
          } else {
            vm.listingPurchase = false
          }
        }

        // create string rule
        rulet += 'Listing - '

        if (rule['pur'] !== undefined) {
          rulet += 'Listings Purchase ' + (rule['pur'] ? 'Yes' : 'No') + ', '
        }
        if (rule['lc-min'] !== undefined) {
          rulet += 'Listings Count Min ' + rule['lc-min'] + ', '
        }
        if (rule['lc-max'] !== undefined) {
          rulet += 'Listings Count Max ' + rule['lc-max'] + ' - '
        }
        if (rule['sc-min'] !== undefined) {
          rulet += 'Sales Count Min ' + rule['sc-min'] + ', '
        }
        if (rule['sc-max'] !== undefined) {
          rulet += 'Sales Count Max ' + rule['sc-max'] + ' - '
        }
        if (rule['sa-min'] !== undefined) {
          rulet += 'Sales Amount Min ' + rule['sa-min'] + ', '
        }
        if (rule['sa-max'] !== undefined) {
          rulet += 'Sales Amount Max ' + rule['sa-max'] + ' - '
        }
        if (rule['id-ch'] !== undefined) {
          rulet += 'Channel ID ' + rule['id-ch'] + ' - '
        }
        if (rule['id-s'] !== undefined) {
          rulet += 'Set ID ' + rule['id-s'] + ' - '
        }
      } else if (vm.model.k === 14) {
        if (rule['ce-min'] !== undefined) {
          vm.model['ce-min'] = rule['ce-min']
        }
        if (rule['ce-max'] !== undefined) {
          vm.model['ce-max'] = rule['ce-max']
        }
        if (rule['ec-min'] !== undefined) {
          vm.model['ec-min'] = rule['ec-min']
        }
        if (rule['ec-max'] !== undefined) {
          vm.model['ec-max'] = rule['ec-max']
        }

        // create string rule
        rulet += 'Fyber - '

        if (rule['ce-min'] !== undefined) {
          rulet += 'Coins Earned Min ' + rule['ce-min'] + ', '
        }
        if (rule['ce-max'] !== undefined) {
          rulet += 'Coins Earned Max ' + rule['ce-max'] + ' - '
        }
        if (rule['ec-min'] !== undefined) {
          rulet += 'Earned Count Min ' + rule['ec-min'] + ', '
        }
        if (rule['ec-max'] !== undefined) {
          rulet += 'Earned Count Max ' + rule['ec-max'] + ' - '
        }
      } else if (vm.model.k === 15) {
        if (rule['c-min'] !== undefined) {
          vm.model['c-min'] = rule['c-min']
        }
        if (rule['c-max'] !== undefined) {
          vm.model['c-max'] = rule['c-max']
        }

        // create string rule
        rulet += 'Coin Wallet - '

        if (rule['c-min'] !== undefined) {
          rulet += 'Coins Min ' + rule['c-min'] + ', '
        }
        if (rule['c-max'] !== undefined) {
          rulet += 'Coins Max ' + rule['c-max']
        }
      } else if (vm.model.k === 16) {
        if (rule['cl-min'] !== undefined) {
          vm.model['cl-min'] = rule['cl-min']
        }
        if (rule['cl-max'] !== undefined) {
          vm.model['cl-max'] = rule['cl-max']
        }
        if (rule['c-min'] !== undefined) {
          vm.model['c-min'] = rule['c-min']
        }
        if (rule['c-max'] !== undefined) {
          vm.model['c-max'] = rule['c-max']
        }

        // create string rule
        rulet += 'Coin Claim - '

        if (rule['cl-min'] !== undefined) {
          rulet += 'Claims Min ' + rule['cl-min'] + ', '
        }
        if (rule['cl-max'] !== undefined) {
          rulet += 'Claims Max ' + rule['cl-max'] + ' - '
        }
        if (rule['c-min'] !== undefined) {
          rulet += 'Coins Min ' + rule['c-min'] + ', '
        }
        if (rule['c-max'] !== undefined) {
          rulet += 'Coins Max ' + rule['c-max']
        }
      } else if (vm.model.k === 17) {
        if (rule['cpo-min'] !== undefined) {
          vm.model['cpo-min'] = rule['cpo-min']
        }
        if (rule['cpo-max'] !== undefined) {
          vm.model['cpo-max'] = rule['cpo-max']
        }
        if (rule['cqo-min'] !== undefined) {
          vm.model['cqo-min'] = rule['cqo-min']
        }
        if (rule['cqo-max'] !== undefined) {
          vm.model['cqo-max'] = rule['cqo-max']
        }

        // create string rule
        rulet += 'Collection Size - '

        if (rule['cpo-min'] !== undefined) {
          rulet += 'Prints Min ' + rule['cpo-min'] + ', '
        }
        if (rule['cpo-max'] !== undefined) {
          rulet += 'Prints Max ' + rule['cpo-max'] + ' - '
        }
        if (rule['cqo-min'] !== undefined) {
          rulet += 'Collectibles Min ' + rule['cqo-min'] + ', '
        }
        if (rule['cqo-max'] !== undefined) {
          rulet += 'Collectibles Max ' + rule['cqo-max']
        }
      } else if (vm.model.k === 18) {
        if (rule['id-q'] !== undefined) {
          var ids = rule['id-q'].join(',')
          UserSegmentationService.listCollectibleByIds(ids).then(function (result) {
            var collectibles = result.results
            vm.model['id-q'] = rule['id-q']
            $('#e9').select2('data', collectibles)
            var idsConcat = ''
            vm.model['id-q'].map(function (item) {
              idsConcat += item + ','
            })
            rulet += 'Owns Collectible IDs - ' + idsConcat + ', '
          })
        }

        if (rule['r-val-min'] !== undefined) {
          rulet += 'Value Rank min ' + rule['r-val-min'] + ', '

          vm.checkValue = true
          vm.isTotalSpentUser2 = true
          vm.model['r-val-min'] = rule['r-val-min']
        }
        if (rule['r-val-max'] !== undefined) {
          rulet += 'Value Rank max ' + rule['r-val-max'] + ' - '

          vm.checkValue = true
          vm.isTotalSpentUser2 = true
          vm.model['r-val-max'] = rule['r-val-max']
        }

        if (rule['all'] !== undefined) {
          vm.model['all'] = rule['all']
          rulet += ' All - ' + rule['all']
        }
      } else if (vm.model.k === 19) {
        if (rule['val-min'] !== undefined) {
          vm.model['val-min'] = rule['val-min']
        }
        if (rule['val-max'] !== undefined) {
          vm.model['val-max'] = rule['val-max']
        }

        // create string rule
        rulet += 'Collection Value - '

        if (rule['val-min'] !== undefined) {
          rulet += 'Value Min ' + rule['val-min'] + ', '
        }
        if (rule['val-max'] !== undefined) {
          rulet += 'Value Max ' + rule['val-max']
        }
      } else if (vm.model.k === 20) {
        if (rule['id-seg'] !== undefined) {
          UserSegmentationService.getByIds(rule['id-seg']).then(function (result) {
            vm.model['id-seg'] = rule['id-seg']
            $('#e15').select2('data', result.results)
            var idsConcat = ''
            vm.model['id-seg'].map(function (item) {
              idsConcat += item + ','
            })
            rulet += 'Or Segment IDs - ' + idsConcat
          })
        }
      } else if (vm.model.k === 21) {
        rulet += 'Region - '

        if (rule['id-ch'] !== undefined) {
          var channel = _.find(vm.channels, { id: rule['id-ch'] })
          vm.channelId = channel.id
          rulet += 'Channel ID ' + rule['id-ch']
        }
        if (rule['lcs'] !== undefined) {
          vm.model['lcs'] = rule['lcs']
          rulet += 'Locales ' + rule['lcs']
        }
      } else if (vm.model.k === 22) {
        rulet += 'Language - '

        if (rule['lang'] !== undefined) {
          vm.model['lang'] = rule['lang']
          rulet += 'Languages ' + rule['lang']
        }
        if (rule['comm'] !== undefined) {
          vm.model['comm'] = rule['comm']
          rulet += 'Communities ' + rule['comm']
        }
      } else if (vm.model.k === 23) {
        rulet += 'Coupon - '
        if (rule['id-cpn']) {
          CouponsService.getByIds(rule['id-cpn'].join(',')).then(function (results) {
            $('#couponSelect').select2('data', results.results)
          })
          vm.model['id-cpn'] = rule['id-cpn']
          rulet += 'Coupon IDs ' + rule['id-cpn']
        }

        if (rule['cc-min']) {
          rulet += 'Count Min ' + rule['cc-min'] + ', '
          vm.model['cc-min'] = rule['cc-min']
        }
        if (rule['cc-max']) {
          rulet += 'Count Max ' + rule['cc-max']
          vm.model['cc-max'] = rule['cc-max']
        }
      } else if (vm.model.k === 24) {
        rulet += 'User Notification Preferences - '

        if (rule['k']) {
          vm.model.unp['k'] = rule['k']
          rulet += 'Notification Type ' + rule['k']
        }
        if (rule['met']) {
          vm.model.unp['met'] = rule['met']
          rulet += 'Notification Method ' + rule['met']
        }
        if (rule['enabled']) {
          vm.model.unp['enabled'] = rule['enabled']
          rulet += 'Notification Enabled ' + rule['enabled']
        }
      } else if (vm.model.k === 25) {
        rulet += 'Set Waitlist - '
        UserSegmentationService.listSetsByID(rule['id-s'].join()).then(function (resSets) {
          vm.sets = resSets.results
          UserSegmentationService.getChannelID(vm.sets[0]['id-ch']).then(function (resCh) {
            vm.channelId = resCh.results.id

            vm.model.sw['id-s'] = rule['id-s']
            rulet += 'Set Ids ' + rule['id-s']
            vm.checkSetList = true
            vm.isSetList = true
            vm.model.sets.value = rule['id-s']
            vm.isSetList = true

            if (rule['all']) {
              vm.model.sw['all'] = rule['all']
              rulet += 'All ' + rule['all']
            }
          })
        })
      } else if (vm.model.k === 26) {
        rulet += 'User Signin Activity - '

        if (rule['cc-min']) {
          vm.model.usignin['cc-min'] = rule['cc-min']
          rulet += 'Count Min ' + rule['cc-min']
        }
        if (rule['cc-max']) {
          vm.model.usignin['cc-max'] = rule['cc-max']
          rulet += 'Count Max ' + rule['cc-max']
        }
        if (rule['days']) {
          vm.model.usignin['days'] = rule['days']
          rulet += 'Days ' + rule['days']
        }
        if (rule['m']) {
          vm.model.usignin['m'] = rule['m']
          rulet += 'Login Method ' + rule['m']
        }
        if (rule['all']) {
          vm.model.usignin['all'] = rule['all']
          rulet += 'all ' + rule['all']
        }
      } else if (vm.model.k === 27) {
        rulet += 'Burn - '

        if (rule['cc-min']) {
          vm.model.burn['cc-min'] = rule['cc-min']
          rulet += 'Count Min ' + rule['cc-min']
        }
        if (rule['cc-max']) {
          vm.model.burn['cc-max'] = rule['cc-max']
          rulet += 'Count Max ' + rule['cc-max']
        }
        if (rule['id-s']) {
          UserSegmentationService.listSetsByID(rule['id-s']).then(function (resSets) {
            vm.sets = resSets.results
            vm.model.burn['id-s'] = rule['id-s']
            rulet += 'Set Id ' + rule['id-s']

            var channel = _.find(vm.channels, { id: vm.sets[0]['id-ch'] })
            vm.channelId = channel.id

            vm.checkSetList = true
            vm.isSetList = true
          })
        }

        if (rule['id-q']) {
          UserSegmentationService.listCollectibleByIds(rule['id-q'].join()).then(function (resCollectible) {
            vm.collectibles = resCollectible.results

            vm.model.burn['id-q'] = rule['id-q']
            rulet += 'Collectible Ids' + rule['id-q']
            vm.checkCollectibleList = true
            vm.isCollectibleList = true

            var idsConcat = ''
            vm.model.burn['id-q'].map(function (item) {
              idsConcat += item + ','
            })
            rulet += 'Collectible IDs - ' + idsConcat + ', '

            if (rule['all']) {
              vm.model.burn['all'] = rule['all']
              rulet += 'All ' + rule['all']
            }
            $timeout(function () {
              $('#e9').select2('data', vm.collectibles)
            }, 1000)
          })
        }
        if (rule['id-shiny']) {
          UserSegmentationService.listShinyByIds(rule['id-shiny'].join()).then(function (resCollectible) {
            vm.shinies = resCollectible.results

            vm.model.burn['id-shiny'] = rule['id-shiny']
            rulet += 'Shinies Ids' + rule['id-shiny']
            vm.checkShinyList = true
            vm.isShinyList = true

            $('#shinySelect').select2('data', vm.shinies)
            var idsConcat = ''
            vm.model.burn['id-shiny'].map(function (item) {
              idsConcat += item + ','
            })
            rulet += 'Shinies IDs - ' + idsConcat + ', '

            if (rule['all']) {
              vm.model.burn['all'] = rule['all']
              rulet += 'All ' + rule['all']
            }

            $timeout(function () {
              $('#shinySelect').select2('data', vm.shinies)
            }, 1000)
          })
        }
      } else if (vm.model.k === 28) {
        rulet += 'Channel Waitlist - '

        vm.model.chw['id-ch'] = rule['id-ch']
        rulet += 'Channel Ids ' + rule['id-ch']
        // vm.model.sets.value = rule["id-s"];

        if (rule['all']) {
          vm.model.chw['all'] = rule['all']
          rulet += 'All ' + rule['all']
        }
      } else if (vm.model.k === 29) {
        rulet += 'Drop Waitlist - '

        vm.model.dhw['id-dr'] = rule['id-dr']
        rulet += 'Drop Ids ' + rule['id-dr']

        if (rule['all']) {
          vm.model.dhw['all'] = rule['all']
          rulet += 'All ' + rule['all']
        }
      } else if (vm.model.k === 30) {
        rulet += 'User status - '

        vm.model.user_status['kyc-st'] = rule['kyc-st']
        rulet += 'KYC Status ' + rule['kyc-st']

        vm.model.user_status['verified'] = rule['verified']
        rulet += 'Verified ' + rule['verified']

        vm.model.user_status['email-verified'] = rule['email-verified']
        rulet += 'Email Verified ' + rule['email-verified'] ? 'Yes' : 'No'

        vm.model.user_status['2fa-enabled'] = rule['2fa-enabled']
        rulet += '2FA Enabled ' + rule['2fa-enabled'] ? 'Yes' : 'No'

        vm.model.user_status['2fa-type'] = rule['2fa-type']
        rulet += '2FA Type ' + rule['2fa-type'] ? 'Yes' : 'No'
      }

      if (rule['ts-start'] !== undefined) {
        var date1 = new moment(
          parseInt(
            rule['ts-start'].toString().substring(0, rule['ts-start'].toString().length - 3),
          ),
        ).format('L')
        rulet += 'Time ' + date1 + ' - '

        vm.isTypeDate = 'absolute'
        vm.date1 = new Date(
          parseInt(
            rule['ts-start'].toString().substring(0, rule['ts-start'].toString().length - 3),
          ),
        )
      }

      if (rule['ts-end'] !== undefined) {
        var date2 = new moment(
          parseInt(rule['ts-end'].toString().substring(0, rule['ts-end'].toString().length - 3)),
        ).format('L')
        rulet += date2

        vm.isTypeDate = 'absolute'
        vm.date2 = new Date(
          parseInt(rule['ts-end'].toString().substring(0, rule['ts-end'].toString().length - 3)),
        )
      }

      if (rule['dur-min'] !== undefined && rule['dur-max'] !== undefined) {
        rulet += 'Time ' + rule['dur-min'] + ' - ' + rule['dur-max']

        vm.isTypeDate = 'relative'
        var min1 = angular.copy(rule['dur-min'])
        var max1 = angular.copy(rule['dur-max'])
        if (min1.indexOf('h') !== -1) {
          min1 = parseInt(min1.replace('h', '').replace('m', ''))
          if (min1 > 24) {
            vm.durMin = 3
            vm.model['dur-min'] = parseInt(rule['dur-min'].replace('h', '').replace('m', '')) / 24
          } else {
            vm.durMin = 2
            vm.model['dur-min'] = parseInt(rule['dur-min'].replace('h', '').replace('m', ''))
          }
        } else if (min1.indexOf('m') !== -1) {
          vm.durMin = 1
          vm.model['dur-min'] = parseInt(rule['dur-min'].replace('h', '').replace('m', ''))
        }

        if (max1.indexOf('h') !== -1) {
          max1 = parseInt(max1.replace('h', '').replace('m', ''))
          if (max1 > 24) {
            vm.durMax = 3
            vm.model['dur-max'] = parseInt(rule['dur-max'].replace('h', '').replace('m', '')) / 24
          } else {
            vm.durMax = 2
            vm.model['dur-max'] = parseInt(rule['dur-max'].replace('h', '').replace('m', ''))
          }
        } else {
          vm.durMax = 1
          vm.model['dur-max'] = parseInt(rule['dur-max'].replace('h', '').replace('m', ''))
        }
      }

      if (rule['days-min'] !== undefined && rule['days-max'] !== undefined) {
        rulet += 'Days ' + rule['days-min'] + ' - ' + rule['days-max']
        vm.isTypeDate = 'whole_days'
        vm.model['days-min'] = rule['days-min']
        vm.model['days-max'] = rule['days-max']
      }
      if (rule['days-min'] !== undefined && !rule['days-max']) {
        rulet += 'Days ' + rule['days-min']
        vm.isTypeDate = 'whole_days'
        vm.model['days-min'] = rule['days-min']
      }
      if (!rule['days-min'] && rule['days-max'] !== undefined) {
        rulet += 'Days ' + rule['days-max']
        vm.isTypeDate = 'whole_days'
        vm.model['days-max'] = rule['days-max']
      }

      vm.model.rulet = rulet

      loadLinked()
    })
  }

  function loadLinked() {
    vm.notLinked = false
    UserSegmentationService.listAssociate(vm.currentID).then(function (result) {
      var items = result.results
      if (items.length === 0) {
        vm.notLinked = true
      } else {
        var newList = []
        if (items.p !== undefined) {
          for (var j = 0; j < items.p.length; j++) {
            newList.push(items.p[j])
          }
        }
        if (items.b !== undefined) {
          for (var k = 0; k < items.b.length; k++) {
            newList.push(items.b[k])
          }
        }
        if (items.es !== undefined) {
          for (var z = 0; z < items.es.length; z++) {
            items.es[z].t = items.es[z].nm
            newList.push(items.es[z])
          }
        }
        vm.listLinked = newList
      }
    })
  }

  CoinProductService.list().then(function (result) {
    vm.coinProducts = result.results
  })

  vm.verificationStatus = [
    { id: 'success', name: 'Success' },
    { id: 'fail', name: 'Fail' },
    { id: 'awaiting_user_input', name: 'Awaiting User Input' },
    { id: 'processing_data', name: 'Processing Data' },
    { id: 'expired', name: 'Expired' },
    { id: 'awaiting_manual_review', name: 'Awaiting Manual Review' },
    { id: 'manual_success', name: 'Manual Success' },
    { id: 'manual_fail', name: 'Manual Fail' },
  ]

  vm.openCalendar = function (e, type) {
    e.preventDefault()
    e.stopPropagation()

    if (type === 1) {
      vm.isOpen = true
    } else if (type === 2) {
      vm.isOpen1 = true
    }
  }

  vm.save = function () {
    if (vm.model.t === undefined || vm.model.t === null || vm.model.t === '') {
      swal('Title is required', '', 'error')
      return
    }

    if (vm.model.txt === undefined || vm.model.txt === null || vm.model.txt === '') {
      swal('Description is required', '', 'error')
      return
    }

    if (vm.model.k === undefined || vm.model.k === null || vm.model.k === '') {
      swal('Type is required', '', 'error')
      return
    }

    if (vm.orFlow) {
      if (vm.modelOr.t === undefined || vm.modelOr.t === null || vm.modelOr.t === '') {
        swal('OR - Title is required', '', 'error')
        return
      }

      if (vm.modelOr.txt === undefined || vm.modelOr.txt === null || vm.modelOr.txt === '') {
        swal('OR - Description is required', '', 'error')
        return
      }

      if (vm.modelOr.k === undefined || vm.modelOr.k === null || vm.modelOr.k === '') {
        swal('OR - Type is required', '', 'error')
        return
      }
    }

    var model = {
      t: vm.model.t,
      txt: vm.model.txt,
      k: vm.model.k === 5.1 ? 5 : vm.model.k,
      rule: {},
      'id-cb': userId,
    }

    if (model.k === 1) {
      model.rule['id-p'] = vm.model.cp.value

      if (!vm.isProductPrice) {
        if (vm.isGroupButton1) {
          model.rule.all = true
        } else {
          delete model.rule.all
        }
      }

      if (vm.model.pp.min !== undefined) {
        model.rule['price-min'] = vm.model.pp.min
      }

      if (vm.model.pp.max !== undefined) {
        model.rule['price-max'] = vm.model.pp.max
      }

      if (vm.model.tsu.min !== undefined) {
        model.rule['spent-min'] = vm.model.tsu.min
      }

      if (vm.model.tsu.max !== undefined) {
        model.rule['spent-max'] = vm.model.tsu.max
      }

      if (vm.model.tpu.min !== undefined) {
        model.rule['cp-min'] = vm.model.tpu.min
      }

      if (vm.model.tpu.max !== undefined) {
        model.rule['cp-max'] = vm.model.tpu.max
      }

      if (vm.model['pr-k'] !== undefined) {
        model.rule['pr-k'] = vm.model['pr-k']
      }

      if (_.isEmpty(model.rule['pr-k'])) {
        delete model.rule['pr-k']
      }

      if (vm.model['store'] !== undefined) {
        model.rule['store'] = vm.model['store']
      }
    } else if (model.k === 2) {
      vm.model.bundles.value = $('#e8')
        .select2('val')
        .map(function (item) {
          return parseInt(item)
        })

      if (vm.model.bundles.value === undefined || vm.model.bundles.value.length === 0) {
        delete model.rule['id-b']
      } else {
        model.rule['id-b'] = vm.model.bundles.value
      }

      if (vm.channelId) {
        model.rule['id-ch'] = vm.channelId
      }

      var setId = parseInt($('#setSelect').select2('val'))
      console.log(setId)
      if (setId) {
        model.rule['id-s'] = setId
      }

      if (vm.isGroupButton1) {
        model.rule.all = true
      } else {
        delete model.rule.all
      }

      if (vm.model['cbp-min'] !== undefined) {
        model.rule['cbp-min'] = vm.model['cbp-min']
      }
      if (vm.model['cbp-max'] !== undefined) {
        model.rule['cbp-max'] = vm.model['cbp-max']
      }

      if (vm.model['spent-min'] !== undefined) {
        model.rule['spent-min'] = vm.model['spent-min']
      }
      if (vm.model['spent-max'] !== undefined) {
        model.rule['spent-max'] = vm.model['spent-max']
      }

      if (vm.model['spent-min-cash'] !== undefined) {
        model.rule['spent-min-cash'] = vm.model['spent-min-cash']
      }
      if (vm.model['spent-max-cash'] !== undefined) {
        model.rule['spent-max-cash'] = vm.model['spent-max-cash']
      }

      if (vm.checkIncludeFree) {
        model.rule['inc-free'] = true
      } else {
        delete model.rule['inc-free']
      }
    } else if (model.k === 3) {
      model.rule['id-s'] = vm.model.sets.value
      if (vm.isGroupButton1) {
        model.rule.all = true
      } else {
        delete model.rule.all
      }

      if (vm.model['r-val-min'] !== undefined) {
        model.rule['r-val-min'] = vm.model['r-val-min']
      }
      if (vm.model['r-val-max'] !== undefined) {
        model.rule['r-val-max'] = vm.model['r-val-max']
      }

      if (vm.model['r-comp-min'] !== undefined) {
        model.rule['r-comp-min'] = vm.model['r-comp-min']
      }
      if (vm.model['r-comp-max'] !== undefined) {
        model.rule['r-comp-max'] = vm.model['r-comp-max']
      }

      model.rule['id-ch'] = vm.channelId
    } else if (model.k === 4) {
      if (vm.model.channel['r-val-min'] !== undefined) {
        model.rule['r-val-min'] = vm.model.channel['r-val-min']
      }
      if (vm.model.channel['r-val-max'] !== undefined) {
        model.rule['r-val-max'] = vm.model.channel['r-val-max']
      }
      if (vm.model.channel['k-album'] !== undefined) {
        model.rule['k-album'] = vm.model.channel['k-album']
      }
      model.rule['id-ch'] = vm.channelId
    } else if (model.k === 5) {
      model.rule['id-promo'] = parseInt(vm.model['id-promo'])
      model.rule['id-pc'] = parseInt(vm.campaignId)
    } else if (model.k === 6) {
      model.rule['id-u'] = []
      for (var i = 0; i < vm.listUsers.length; i++) {
        model.rule['id-u'].push(vm.listUsers[i].id)
      }

      var ids = vm.inputIds.split(',')
      ids.map(function (item) {
        if (isNumber(parseInt(item))) {
          model.rule['id-u'].push(parseInt(item))
        }
      })

      model.rule['id-u'] = _.uniqBy(model.rule['id-u'])
    } else if (model.k === 7) {
      if (
        vm.model['c-cohort'] === undefined ||
        vm.model['c-cohort'] === null ||
        vm.model['c-cohort'] === ''
      ) {
        swal('Cohort Count is required', '', 'error')
        return
      }

      if (vm.model.ctm === undefined || vm.model.ctm === null || vm.model.ctm === '') {
        swal('Cohort To Match is required', '', 'error')
        return
      }

      model.rule['c-cohort'] = parseInt(vm.model['c-cohort'])
      model.rule.ctm = parseInt(vm.model.ctm)
    } else if (model.k === 8) {
      vm.model['id-seg'] = $('#e15')
        .select2('val')
        .map(function (item) {
          return parseInt(item)
        })
      if (
        vm.model['id-seg'] === undefined ||
        vm.model['id-seg'] === null ||
        vm.model['id-seg'].length === 0
      ) {
        swal('And Segment IDs is required', '', 'error')
        return
      }
      model.rule['id-seg'] = vm.model['id-seg']
    } else if (model.k === 9) {
      vm.model['id-seg'] = $('#e15')
        .select2('val')
        .map(function (item) {
          return parseInt(item)
        })
      if (
        vm.model['id-seg'] === undefined ||
        vm.model['id-seg'] === null ||
        vm.model['id-seg'].length === 0
      ) {
        swal('Xor Segment IDs is required', '', 'error')
        return
      }
      model.rule['id-seg'] = vm.model['id-seg']
    } else if (model.k === 10) {
      vm.model['id-seg'] = $('#e15')
        .select2('val')
        .map(function (item) {
          return parseInt(item)
        })
      if (
        vm.model['id-seg'] === undefined ||
        vm.model['id-seg'] === null ||
        vm.model['id-seg'].length === 0
      ) {
        swal('Not Segment IDs is required', '', 'error')
        return
      }
      model.rule['id-seg'] = vm.model['id-seg']
    } else if (model.k === 11) {
      vm.model['id-seg'] = $('#e15')
        .select2('val')
        .map(function (item) {
          return parseInt(item)
        })
      if (
        vm.model['id-seg'] === undefined ||
        vm.model['id-seg'] === null ||
        vm.model['id-seg'].length === 0
      ) {
        swal('Exclude Segment IDs is required', '', 'error')
        return
      }

      if (vm.model['id-sseg'] === undefined || vm.model['id-sseg'] === null) {
        swal('Starting Segment ID is required', '', 'error')
        return
      }
      model.rule['id-seg'] = vm.model['id-seg']
      model.rule['id-sseg'] = vm.model['id-sseg']
    } else if (model.k === 13) {
      if (!vm.model['lc-min']) {
        swal('Listings Count Min is required', '', 'error')
        return
      }

      model.rule['lc-min'] = vm.model['lc-min']
      model.rule['lc-max'] = vm.model['lc-max']
      model.rule['sc-min'] = vm.model['sc-min']
      model.rule['sc-max'] = vm.model['sc-max']
      model.rule['sa-min'] = vm.model['sa-min']
      model.rule['sa-max'] = vm.model['sa-max']
      if (vm.channelId) {
        model.rule['id-ch'] = [vm.channelId]
      } else {
        delete model.rule['id-ch']
      }
      if (vm.setId2) {
        model.rule['id-s'] = [vm.setId2]
      } else {
        delete model.rule['id-s']
      }
      model.rule['pur'] = vm.listingPurchase ? true : false
    } else if (model.k === 14) {
      model.rule['ce-min'] = vm.model['ce-min']
      model.rule['ce-max'] = vm.model['ce-max']
      model.rule['ec-min'] = vm.model['ec-min']
      model.rule['ec-max'] = vm.model['ec-max']
    } else if (model.k === 15) {
      model.rule['c-min'] = vm.model['c-min']
      model.rule['c-max'] = vm.model['c-max']
    } else if (model.k === 16) {
      model.rule['cl-min'] = vm.model['cl-min']
      model.rule['cl-max'] = vm.model['cl-max']
      model.rule['c-min'] = vm.model['c-min']
      model.rule['c-max'] = vm.model['c-max']
    } else if (model.k === 17) {
      model.rule['cpo-min'] = vm.model['cpo-min']
      model.rule['cpo-max'] = vm.model['cpo-max']
      model.rule['cqo-min'] = vm.model['cqo-min']
      model.rule['cqo-max'] = vm.model['cqo-max']
    } else if (model.k === 18) {
      vm.model['id-q'] = $('#e9')
        .select2('val')
        .map(function (item) {
          return parseInt(item)
        })

      if (vm.collectibleIds && vm.collectibleIds.length > 0) {
        vm.model['id-q'] = vm.collectibleIds
      }

      if (
        vm.model['id-q'] === undefined ||
        vm.model['id-q'] === null ||
        vm.model['id-q'].length === 0
      ) {
        swal('Collectible IDs is required', '', 'error')
        return
      }

      if (vm.model['r-val-min'] !== undefined) {
        model.rule['r-val-min'] = vm.model['r-val-min']
      }
      if (vm.model['r-val-max'] !== undefined) {
        model.rule['r-val-max'] = vm.model['r-val-max']
      }

      model.rule['id-q'] = vm.model['id-q']
      model.rule['all'] = vm.model['all']
    } else if (model.k === 19) {
      model.rule['val-min'] = vm.model['val-min']
      model.rule['val-max'] = vm.model['val-max']
    } else if (model.k === 20) {
      vm.model['id-seg'] = $('#e15')
        .select2('val')
        .map(function (item) {
          return parseInt(item)
        })

      if (
        vm.model['id-seg'] === undefined ||
        vm.model['id-seg'] === null ||
        vm.model['id-seg'].length === 0
      ) {
        swal('Or Segment IDs is required', '', 'error')
        return
      }
      model.rule['id-seg'] = vm.model['id-seg']
    } else if (model.k === 21) {
      if (vm.channelId) {
        model.rule['id-ch'] = parseInt(vm.channelId)
      } else {
        delete model.rule['id-ch']
      }
      if (vm.model.lcs) {
        model.rule.lcs = vm.model.lcs
      } else {
        delete model.rule.lcs
      }
    } else if (model.k === 22) {
      if (vm.model.lang) {
        model.rule.lang = vm.model.lang
      } else {
        delete model.rule.lang
      }
      if (vm.model.comm) {
        model.rule.comm = vm.model.comm
      } else {
        delete model.rule.comm
      }
    } else if (model.k === 23) {
      var couponsId = $('#couponSelect')
        .select2('val')
        .map(function (item) {
          return parseInt(item)
        })
      if (couponsId) {
        model.rule['id-cpn'] = couponsId
      }
      model.rule['cc-min'] = vm.model['cc-min']
      model.rule['cc-max'] = vm.model['cc-max']
    } else if (model.k === 24) {
      model.rule['met'] = vm.model.unp['met']
      model.rule['k'] = vm.model.unp['k']
      model.rule['enabled'] = vm.model.unp['enabled']
    } else if (model.k === 25) {
      model.rule['id-s'] = vm.model.sw['id-s']
      model.rule['all'] = vm.model.sw['all']
    } else if (model.k === 26) {
      model.rule['cc-min'] = vm.model.usignin['cc-min']
      model.rule['cc-max'] = vm.model.usignin['cc-max']
      model.rule['days'] = vm.model.usignin['days']
      model.rule['m'] = vm.model.usignin['m']
      model.rule['all'] = vm.model.usignin['all']
    } else if (model.k === 27) {
      model.rule['cc-min'] = vm.model.burn['cc-min']
      model.rule['cc-max'] = vm.model.burn['cc-max']
      model.rule['all'] = vm.model.burn['all']
      model.rule['id-s'] = vm.model.burn['id-s']

      vm.model['id-q'] = $('#e9')
        .select2('val')
        .map(function (item) {
          return parseInt(item)
        })

      vm.model['id-shiny'] = $('#shinySelect')
        .select2('val')
        .map(function (item) {
          return parseInt(item)
        })

      if (vm.collectibleIds && vm.collectibleIds.length > 0) {
        vm.model['id-q'] = vm.collectibleIds
      }

      model.rule['id-q'] = vm.model['id-q']
      model.rule['id-shiny'] = vm.model['id-shiny']

      if (vm.isCollectibleList) {
        delete model.rule['id-s']
        delete model.rule['id-shiny']
      }
      if (vm.checkSetList) {
        delete model.rule['id-q']
        delete model.rule['id-shiny']
      }
      if (vm.isShinyList) {
        delete model.rule['id-s']
        delete model.rule['id-q']
      }
    } else if (model.k === 28) {
      model.rule['id-ch'] = vm.model.chw['id-ch']
      model.rule['all'] = vm.model.chw['all']
    } else if (model.k === 29) {
      model.rule['id-dr'] = vm.model.dhw['id-dr']
      model.rule['all'] = vm.model.dhw['all']
    } else if (vm.model.k === 30) {
      model.rule['kyc-st'] = vm.model.user_status['kyc-st']
      model.rule['verified'] = vm.model.user_status['verified']
      model.rule['email-verified'] = vm.model.user_status['email-verified']
      model.rule['2fa-enabled'] = vm.model.user_status['2fa-enabled']
      model.rule['2fa-type'] = vm.model.user_status['2fa-type']
    }

    var modelOr = {}
    if (vm.orFlow) {
      modelOr = {
        t: vm.modelOr.t,
        txt: vm.modelOr.txt,
        k: vm.modelOr.k,
        rule: {},
        'id-cb': userId,
      }

      if (modelOr.k === 8) {
        vm.modelOr['id-seg'] = parseInt($('#e15').select2('val'))
        if (
          vm.modelOr['id-seg'] === undefined ||
          vm.modelOr['id-seg'] === null ||
          vm.modelOr['id-seg'].length === 0 ||
          vm.modelOr['id-seg'] === '' ||
          vm.modelOr['id-seg'] === 0
        ) {
          swal('And Segment IDs is required', '', 'error')
          return
        }
        modelOr.rule['id-seg'] = vm.modelOr['id-seg']
      } else if (modelOr.k === 9) {
        vm.modelOr['id-seg'] = parseInt($('#e15').select2('val'))
        if (
          vm.modelOr['id-seg'] === undefined ||
          vm.modelOr['id-seg'] === null ||
          vm.modelOr['id-seg'].length === 0 ||
          vm.modelOr['id-seg'] === '' ||
          vm.modelOr['id-seg'] === 0
        ) {
          swal('Xor Segment IDs is required', '', 'error')
          return
        }
        modelOr.rule['id-seg'] = vm.modelOr['id-seg']
      } else if (modelOr.k === 10) {
        vm.modelOr['id-seg'] = parseInt($('#e15').select2('val'))
        if (
          vm.modelOr['id-seg'] === undefined ||
          vm.modelOr['id-seg'] === null ||
          vm.modelOr['id-seg'].length === 0 ||
          vm.modelOr['id-seg'] === '' ||
          vm.modelOr['id-seg'] === 0
        ) {
          swal('Not Segment IDs is required', '', 'error')
          return
        }
        modelOr.rule['id-seg'] = vm.modelOr['id-seg']
      } else if (modelOr.k === 20) {
        vm.modelOr['id-seg'] = parseInt($('#e15').select2('val'))
        if (
          vm.modelOr['id-seg'] === undefined ||
          vm.modelOr['id-seg'] === null ||
          vm.modelOr['id-seg'].length === 0 ||
          vm.modelOr['id-seg'] === '' ||
          vm.modelOr['id-seg'] === 0
        ) {
          swal('Or Segment IDs is required', '', 'error')
          return
        }
        modelOr.rule['id-seg'] = vm.modelOr['id-seg']
      }

      modelOr.rule = JSON.stringify(modelOr.rule)
    }

    if (vm.isTypeDate === 'relative') {
      //relative
      var from = ''
      var to = ''
      if (vm.durMin === 1) {
        from = 'm'
        if (
          vm.model['dur-min'] === undefined ||
          vm.model['dur-min'] === '' ||
          vm.model['dur-min'] === null ||
          vm.model['dur-min'] < 0
        ) {
          vm.model['dur-min'] = -525600
        }
      } else if (vm.durMin === 2) {
        from = 'h'
      } else if (vm.durMin === 3) {
        if (
          vm.model['dur-min'] === undefined ||
          vm.model['dur-min'] === '' ||
          vm.model['dur-min'] === null ||
          vm.model['dur-min'] < 0
        ) {
          vm.model['dur-min'] = -10000
          model.rule['dur-min'] = vm.model['dur-min']
        } else {
          model.rule['dur-min'] = vm.model['dur-min'] * 24
        }
        from = 'h'
      }

      if (vm.durMax === 1) {
        to = 'm'
      } else if (vm.durMax === 2) {
        to = 'h'
      } else if (vm.durMax === 3) {
        model.rule['dur-max'] = vm.model['dur-max'] * 24
        to = 'h'
      }

      if (vm.durMin !== 3) {
        if (
          vm.model['dur-min'] === undefined ||
          vm.model['dur-min'] === '' ||
          vm.model['dur-min'] === null ||
          (vm.model['dur-min'] < 0 && vm.durMin !== 1)
        ) {
          vm.model['dur-min'] = -10000
        }
        model.rule['dur-min'] = vm.model['dur-min'] + from
      } else {
        model.rule['dur-min'] = model.rule['dur-min'] + from
      }

      if (vm.durMax !== 3) {
        model.rule['dur-max'] = vm.model['dur-max'] + to
      } else {
        model.rule['dur-max'] = model.rule['dur-max'] + to
      }
    } else if (vm.isTypeDate === 'absolute') {
      //absolut
      if (isDate(vm.date1)) {
        var date = parseInt(new Date(new Date(vm.date1).setSeconds(0)).getTime() * 1000)
        model.rule['ts-start'] = date
      } else {
        delete model.rule['ts-start']
      }
      if (isDate(vm.date2)) {
        var date = parseInt(new Date(new Date(vm.date2).setSeconds(0)).getTime() * 1000)
        model.rule['ts-end'] = date
      } else {
        delete model.rule['ts-end']
      }

      if (model.rule['ts-start'] === 0) {
        //model.rule['ts-start'] = parseInt(new Date('2017-01-02').getTime() + '000');
        delete model.rule['ts-start']
      }

      if (model.rule['ts-end'] === 0) {
        delete model.rule['ts-end']
      }
    } else {
      // whole days
      delete model.rule['ts-start']
      delete model.rule['ts-end']
      delete model.rule['dur-min']
      delete model.rule['dur-max']

      model.rule['days-min'] = vm.model['days-min']
      model.rule['days-max'] = vm.model['days-max']
    }

    model.rule = JSON.stringify(model.rule)
    if (vm.currentID !== '0' && vm.currentID !== null && vm.currentID !== undefined) {
      if (model.k === 3 && vm.model.sets.value === undefined) {
        swal(
          {
            title: 'Are you sure ?',
            text: 'You want save without a Set',
            type: 'warning',
            showCancelButton: true,
            closeOnConfirm: true,
            animation: 'slide-from-top',
          },
          function (isConfirm) {
            if (isConfirm) {
              UserSegmentationService.update(vm.currentID, model).then(function (result) {
                if (vm.isCheckListPage) {
                  localStorage.setItem('checklist_segment_id', result.results.id)
                  $timeout(function () {
                    $('#modalSegmentation').modal('hide')
                  }, 500)
                } else {
                  $state.go('admin.user_segmentation')
                }
              })
            }
          },
        )
      } else if (model.k === 2 && vm.model.bundles.value === undefined) {
        swal(
          {
            title: 'Are you sure ?',
            text: 'You want save without a Bundle',
            type: 'warning',
            showCancelButton: true,
            closeOnConfirm: true,
            animation: 'slide-from-top',
          },
          function (isConfirm) {
            if (isConfirm) {
              UserSegmentationService.update(vm.currentID, model).then(function (result) {
                if (vm.isCheckListPage) {
                  localStorage.setItem('checklist_segment_id', result.results.id)
                  $timeout(function () {
                    $('#modalSegmentation').modal('hide')
                  }, 500)
                } else {
                  $state.go('admin.user_segmentation')
                }
              })
            }
          },
        )
      } else {
        UserSegmentationService.update(vm.currentID, model).then(function (result) {
          if (vm.isCheckListPage) {
            localStorage.setItem('checklist_segment_id', result.results.id)
            $timeout(function () {
              $('#modalSegmentation').modal('hide')
            }, 500)
          } else {
            $state.go('admin.user_segmentation')
          }
        })
      }
    } else {
      if (model.k === 3 && vm.model.sets.value === undefined) {
        swal(
          {
            title: 'Are you sure ?',
            text: 'You want save without a Set',
            type: 'warning',
            showCancelButton: true,
            closeOnConfirm: true,
            animation: 'slide-from-top',
          },
          function (isConfirm) {
            if (isConfirm) {
              UserSegmentationService.save(model).then(function (result) {
                if (vm.isCheckListPage) {
                  localStorage.setItem('checklist_segment_id', result.results.id)
                  $timeout(function () {
                    $('#modalSegmentation').modal('hide')
                  }, 500)
                } else {
                  $state.go('admin.user_segmentation')
                }
              })
            }
          },
        )
      } else if (model.k === 2 && vm.model.bundles.value === undefined) {
        swal(
          {
            title: 'Are you sure ?',
            text: 'You want save without a Bundle',
            type: 'warning',
            showCancelButton: true,
            closeOnConfirm: true,
            animation: 'slide-from-top',
          },
          function (isConfirm) {
            if (isConfirm) {
              UserSegmentationService.save(model).then(function (result) {
                if (vm.isCheckListPage) {
                  localStorage.setItem('checklist_segment_id', result.results.id)
                  $timeout(function () {
                    $('#modalSegmentation').modal('hide')
                  }, 500)
                } else {
                  $state.go('admin.user_segmentation')
                }
              })
            }
          },
        )
      } else {
        if (vm.orFlow) {
          UserSegmentationService.save(modelOr).then(
            function (result2) {
              UserSegmentationService.save(model).then(
                function (result) {
                  if (vm.isCheckListPage) {
                    localStorage.setItem('checklist_segment_id', result.results.id)
                    $timeout(function () {
                      $('#modalSegmentation').modal('hide')
                    }, 500)
                  } else {
                    $state.go('admin.user_segmentation')
                  }
                },
                function (err) {
                  swal(err.error.message, '', 'error')
                },
              )
            },
            function (err) {
              swal(err.error.message, '', 'error')
            },
          )
        } else {
          UserSegmentationService.save(model).then(
            function (result) {
              if (vm.isCheckListPage) {
                localStorage.setItem('checklist_segment_id', result.results.id)
                $timeout(function () {
                  $('#modalSegmentation').modal('hide')
                }, 500)
              } else {
                $state.go('admin.user_segmentation')
              }
            },
            function (err) {
              swal(err.error.message, '', 'error')
            },
          )
        }
      }
    }
  }

  vm.saveOr = function () {}

  vm.clickGroupButton1 = function (type) {
    if (type === 1) {
      vm.isGroupButton1 = true
    } else {
      vm.isGroupButton1 = false
    }
  }

  vm.clickCoinProduct = function () {
    vm.isCoinProduct = !vm.isCoinProduct
    vm.model.cp = {}
  }

  vm.clickCoinProductCashDeposit = function () {
    if (vm.model['pr-k'] === 4) {
      delete vm.model['pr-k']
    } else {
      vm.model['pr-k'] = 4
    }
  }

  vm.clickProductPrice = function () {
    vm.isProductPrice = !vm.isProductPrice
    vm.model.pp = {}
  }

  vm.clickTotalSpentUser = function () {
    vm.isTotalSpentUser = !vm.isTotalSpentUser
    vm.model.tsu = {}
  }

  vm.clickTotalPurchaseUser = function () {
    vm.isTotalPurchaseUser = !vm.isTotalPurchaseUser
    vm.model.tpu = {}
  }

  vm.clickSetList = function () {
    vm.isSetList = !vm.isSetList
    vm.model.sets.value = []

    vm.model.burn['id-q'] = []
    vm.model.burn['id-shiny'] = []
  }

  vm.clickCollectibleList = function () {
    vm.isCollectibleList = !vm.isCollectibleList

    vm.model.burn['id-s'] = []
    vm.model.burn['id-shiny'] = []
  }

  vm.clickShinyList = function () {
    vm.isShinyList = !vm.isShinyList

    vm.model.burn['id-s'] = []
    vm.model.burn['id-q'] = []
  }

  vm.clickValue = function () {
    vm.isTotalSpentUser2 = !vm.isTotalSpentUser2
    vm.model['r-val-min'] = undefined
    vm.model['r-val-max'] = undefined
  }

  vm.clickCompletation = function () {
    vm.isTotalSpentUser = !vm.isTotalSpentUser
    vm.model['r-comp-min'] = undefined
    vm.model['r-comp-max'] = undefined
  }

  vm.clickBundleList = function () {
    vm.isBundleList = !vm.isBundleList
    vm.model.bundles = {}
    vm.checkIncludeFree = false
  }

  vm.clickPurchaseCount = function () {
    vm.isPurchaseCount = !vm.isPurchaseCount
    vm.model['cbp-min'] = undefined
    vm.model['cbp-max'] = undefined
  }

  vm.clickSpentBundle = function () {
    vm.isSpentBundle = !vm.isSpentBundle
    vm.model['spent-min'] = undefined
    vm.model['spent-max'] = undefined
  }

  vm.clickSpentCashBundle = function () {
    vm.isSpentCashBundle = !vm.isSpentCashBundle
    vm.model['spent-min-cash'] = undefined
    vm.model['spent-max-cash'] = undefined
  }

  vm.clickBundleIds = function (type) {
    if (type === 'channel') {
      vm.bundleBySetId = false
      vm.bundleByBundleId = false
    } else if (type === 'set') {
      vm.bundleByChannelId = false
      vm.bundleByBundleId = false
    } else if (type === 'bundle') {
      vm.bundleBySetId = false
      vm.bundleByChannelId = false
    }

    if (vm.bundleByChannelId) {
      $rootScope.bundleType = type
      return
    }
    if (vm.bundleBySetId) {
      $rootScope.bundleType = type
      return
    }
    if (vm.bundleByBundleId) {
      $rootScope.bundleType = type
      return
    }

    $rootScope.bundleType = ''
  }

  vm.clickCollectibleIds = function (type) {
    if (type === 'channel') {
      vm.collectibleBySetId = false
      vm.collectibleByCollectibleId = false
    } else if (type === 'set') {
      vm.collectibleByChannelId = false
      vm.collectibleByCollectibleId = false
    } else if (type === 'collectible') {
      vm.collectibleBySetId = false
      vm.collectibleByChannelId = false
    } else if (type === 'all') {
      vm.collectibleBySetId = false
      vm.collectibleByChannelId = false
      vm.collectibleByCollectibleId = false
      vm.collectibleByBatchIds = false
      if (vm.collectibleByAll) {
        vm.collectibleByAll = true
      } else {
        vm.collectibleByAll = false
      }
      vm.collectibleIds = []
    } else if (type === 'batch') {
      vm.collectibleBySetId = false
      vm.collectibleByChannelId = false
      vm.collectibleByCollectibleId = false
      vm.collectibleByAll = false
      if (vm.collectibleByBatchIds) {
        vm.collectibleByBatchIds = true
      } else {
        vm.collectibleByBatchIds = false
      }
      vm.collectibleIds = []
    }

    if (vm.collectibleByChannelId) {
      $rootScope.collectibleType = type
      return
    }
    if (vm.collectibleBySetId) {
      $rootScope.collectibleType = type
      return
    }
    if (vm.collectibleByCollectibleId) {
      $rootScope.collectibleType = type
      return
    }

    $rootScope.collectibleType = ''
  }

  vm.multipleCollectibleIds = function () {
    var ids = vm.collectibleBatchIds
      .split(' ')
      .join('')
      .split('\n')
      .map(function (item) {
        return item.trim()
      })
      .join(',')
      .split(',,')
      .join(',')

    UserSegmentationService.listCollectibleByIds(ids).then(
      function (result) {
        var collectiblesIds = []
        for (var i = 0; i < result.results.length; i++) {
          collectiblesIds.push(result.results[i].id)
        }
        vm.collectibleIds = collectiblesIds
      },
      function (err) {
        swal(err.error.message, '', 'error')
      },
    )
  }

  var watch = $scope.$watch('vm.channelId', function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    EventService.listSets(newVal).then(function (response) {
      var oldSets = []
      if (vm.model.sets && vm.model.sets.value) {
        for (var i = 0; i < vm.model.sets.value.length; i++) {
          var setFound = _.find(vm.sets, { id: vm.model.sets.value[i] })
          if (setFound) {
            oldSets.push(setFound)
          }
        }
      }
      vm.sets = response.results.concat(oldSets)
      vm.waitChannel = false
    })
  })

  var watch1 = $scope.$watch('vm.setId2', function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    UserSegmentationService.listBundles(newVal).then(function (response) {
      vm.bundles = response.results
      vm.waitSet = false
    })
  })

  var watch2 = $scope.$watch('vm.campaignId', function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    PromoService.list(newVal).then(function (response) {
      vm.promos = response.results
      vm.waitCampaign = false
    })
  })

  var watch3 = $scope.$watch('vm.setId3', function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    UserSegmentationService.listCollectibles(newVal).then(function (response) {
      var collectiblesIds = []
      for (var i = 0; i < response.results.length; i++) {
        collectiblesIds.push(response.results[i].id)
      }
      vm.collectibleIds = collectiblesIds
    })
  })

  var watch4 = $scope.$watch('vm.model.k', function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    if (newVal === 23) {
    }

    if (newVal === 29) {
      UserSegmentationService.listDrops().then(function (result) {
        for (var i = 0; i < result.results.length; i++) {
          result.results[i].t = !result.results[i].t
            ? result.results[i]?.ch?.t
            : result.results[i].t
        }
        vm.drops = result.results
      })
    }
  })

  var watch5 = $scope.$watch('vm.date1', function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    if (newVal) {
      vm.timezoneDate1NY = moment(newVal).tz('America/New_York').format('MM/DD/YYYY HH:mm A')
      vm.timezoneDate1LA = moment(newVal).tz('America/Los_Angeles').format('MM/DD/YYYY HH:mm A')
    }
  })

  var watch6 = $scope.$watch('vm.date2', function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    if (newVal) {
      vm.timezoneDate2NY = moment(newVal).tz('America/New_York').format('MM/DD/YYYY HH:mm A')
      vm.timezoneDate2LA = moment(newVal).tz('America/Los_Angeles').format('MM/DD/YYYY HH:mm A')
    }
  })

  $scope.$on('$destroy', function () {
    watch()
    watch1()
    watch2()
    watch3()
    watch4()
    watch5()
    watch6()
  })

  vm.locales = [
    { value: 'AF', label: 'Afghanistan' },
    { value: 'AX', label: 'Åland Islands' },
    { value: 'AL', label: 'Albania' },
    { value: 'DZ', label: 'Algeria' },
    { value: 'AS', label: 'American Samoa' },
    { value: 'AD', label: 'Andorra' },
    { value: 'AO', label: 'Angola' },
    { value: 'AI', label: 'Anguilla' },
    { value: 'AQ', label: 'Antarctica' },
    { value: 'AG', label: 'Antigua and Barbuda' },
    { value: 'AR', label: 'Argentina' },
    { value: 'AM', label: 'Armenia' },
    { value: 'AW', label: 'Aruba' },
    { value: 'AU', label: 'Australia' },
    { value: 'AT', label: 'Austria' },
    { value: 'AZ', label: 'Azerbaijan' },
    { value: 'BS', label: 'Bahamas' },
    { value: 'BH', label: 'Bahrain' },
    { value: 'BD', label: 'Bangladesh' },
    { value: 'BB', label: 'Barbados' },
    { value: 'BY', label: 'Belarus' },
    { value: 'BE', label: 'Belgium' },
    { value: 'BZ', label: 'Belize' },
    { value: 'BJ', label: 'Benin' },
    { value: 'BM', label: 'Bermuda' },
    { value: 'BT', label: 'Bhutan' },
    { value: 'BO', label: 'Bolivia' },
    { value: 'BA', label: 'Bosnia and Herzegovina' },
    { value: 'BW', label: 'Botswana' },
    { value: 'BV', label: 'Bouvet Island' },
    { value: 'BR', label: 'Brazil' },
    { value: 'IO', label: 'British Indian Ocean Territory' },
    { value: 'BN', label: 'Brunei Darussalam' },
    { value: 'BG', label: 'Bulgaria' },
    { value: 'BF', label: 'Burkina Faso' },
    { value: 'BI', label: 'Burundi' },
    { value: 'KH', label: 'Cambodia' },
    { value: 'CM', label: 'Cameroon' },
    { value: 'CA', label: 'Canada' },
    { value: 'CV', label: 'Cape Verde' },
    { value: 'KY', label: 'Cayman Islands' },
    { value: 'CF', label: 'Central African Republic' },
    { value: 'TD', label: 'Chad' },
    { value: 'CL', label: 'Chile' },
    { value: 'CN', label: 'China' },
    { value: 'CX', label: 'Christmas Island' },
    { value: 'CC', label: 'Cocos (Keeling) Islands' },
    { value: 'CO', label: 'Colombia' },
    { value: 'KM', label: 'Comoros' },
    { value: 'CG', label: 'Congo' },
    { value: 'CD', label: 'Congo, The Democratic Republic of the' },
    { value: 'CK', label: 'Cook Islands' },
    { value: 'CR', label: 'Costa Rica' },
    { value: 'CI', label: "Cote D'Ivoire" },
    { value: 'HR', label: 'Croatia' },
    { value: 'CU', label: 'Cuba' },
    { value: 'CY', label: 'Cyprus' },
    { value: 'CZ', label: 'Czech Republic' },
    { value: 'DK', label: 'Denmark' },
    { value: 'DJ', label: 'Djibouti' },
    { value: 'DM', label: 'Dominica' },
    { value: 'DO', label: 'Dominican Republic' },
    { value: 'EC', label: 'Ecuador' },
    { value: 'EG', label: 'Egypt' },
    { value: 'SV', label: 'El Salvador' },
    { value: 'GQ', label: 'Equatorial Guinea' },
    { value: 'ER', label: 'Eritrea' },
    { value: 'EE', label: 'Estonia' },
    { value: 'ET', label: 'Ethiopia' },
    { value: 'FK', label: 'Falkland Islands (Malvinas)' },
    { value: 'FO', label: 'Faroe Islands' },
    { value: 'FJ', label: 'Fiji' },
    { value: 'FI', label: 'Finland' },
    { value: 'FR', label: 'France' },
    { value: 'GF', label: 'French Guiana' },
    { value: 'PF', label: 'French Polynesia' },
    { value: 'TF', label: 'French Southern Territories' },
    { value: 'GA', label: 'Gabon' },
    { value: 'GM', label: 'Gambia' },
    { value: 'GE', label: 'Georgia' },
    { value: 'DE', label: 'Germany' },
    { value: 'GH', label: 'Ghana' },
    { value: 'GI', label: 'Gibraltar' },
    { value: 'GR', label: 'Greece' },
    { value: 'GL', label: 'Greenland' },
    { value: 'GD', label: 'Grenada' },
    { value: 'GP', label: 'Guadeloupe' },
    { value: 'GU', label: 'Guam' },
    { value: 'GT', label: 'Guatemala' },
    { value: 'GG', label: 'Guernsey' },
    { value: 'GN', label: 'Guinea' },
    { value: 'GW', label: 'Guinea-Bissau' },
    { value: 'GY', label: 'Guyana' },
    { value: 'HT', label: 'Haiti' },
    { value: 'HM', label: 'Heard Island and Mcdonald Islands' },
    { value: 'VA', label: 'Holy See (Vatican City State)' },
    { value: 'HN', label: 'Honduras' },
    { value: 'HK', label: 'Hong Kong' },
    { value: 'HU', label: 'Hungary' },
    { value: 'IS', label: 'Iceland' },
    { value: 'IN', label: 'India' },
    { value: 'ID', label: 'Indonesia' },
    { value: 'IR', label: 'Iran, Islamic Republic Of' },
    { value: 'IQ', label: 'Iraq' },
    { value: 'IE', label: 'Ireland' },
    { value: 'IM', label: 'Isle of Man' },
    { value: 'IL', label: 'Israel' },
    { value: 'IT', label: 'Italy' },
    { value: 'JM', label: 'Jamaica' },
    { value: 'JP', label: 'Japan' },
    { value: 'JE', label: 'Jersey' },
    { value: 'JO', label: 'Jordan' },
    { value: 'KZ', label: 'Kazakhstan' },
    { value: 'KE', label: 'Kenya' },
    { value: 'KI', label: 'Kiribati' },
    { value: 'KP', label: "Korea, Democratic People's Republic of" },
    { value: 'KR', label: 'Korea, Republic of' },
    { value: 'KW', label: 'Kuwait' },
    { value: 'KG', label: 'Kyrgyzstan' },
    { value: 'LA', label: "Lao People's Democratic Republic" },
    { value: 'LV', label: 'Latvia' },
    { value: 'LB', label: 'Lebanon' },
    { value: 'LS', label: 'Lesotho' },
    { value: 'LR', label: 'Liberia' },
    { value: 'LY', label: 'Libyan Arab Jamahiriya' },
    { value: 'LI', label: 'Liechtenstein' },
    { value: 'LT', label: 'Lithuania' },
    { value: 'LU', label: 'Luxembourg' },
    { value: 'MO', label: 'Macao' },
    { value: 'MK', label: 'Macedonia, The Former Yugoslav Republic of' },
    { value: 'MG', label: 'Madagascar' },
    { value: 'MW', label: 'Malawi' },
    { value: 'MY', label: 'Malaysia' },
    { value: 'MV', label: 'Maldives' },
    { value: 'ML', label: 'Mali' },
    { value: 'MT', label: 'Malta' },
    { value: 'MH', label: 'Marshall Islands' },
    { value: 'MQ', label: 'Martinique' },
    { value: 'MR', label: 'Mauritania' },
    { value: 'MU', label: 'Mauritius' },
    { value: 'YT', label: 'Mayotte' },
    { value: 'MX', label: 'Mexico' },
    { value: 'FM', label: 'Micronesia, Federated States of' },
    { value: 'MD', label: 'Moldova, Republic of' },
    { value: 'MC', label: 'Monaco' },
    { value: 'MN', label: 'Mongolia' },
    { value: 'MS', label: 'Montserrat' },
    { value: 'MA', label: 'Morocco' },
    { value: 'MZ', label: 'Mozambique' },
    { value: 'MM', label: 'Myanmar' },
    { value: 'NA', label: 'Namibia' },
    { value: 'NR', label: 'Nauru' },
    { value: 'NP', label: 'Nepal' },
    { value: 'NL', label: 'Netherlands' },
    { value: 'AN', label: 'Netherlands Antilles' },
    { value: 'NC', label: 'New Caledonia' },
    { value: 'NZ', label: 'New Zealand' },
    { value: 'NI', label: 'Nicaragua' },
    { value: 'NE', label: 'Niger' },
    { value: 'NG', label: 'Nigeria' },
    { value: 'NU', label: 'Niue' },
    { value: 'NF', label: 'Norfolk Island' },
    { value: 'MP', label: 'Northern Mariana Islands' },
    { value: 'NO', label: 'Norway' },
    { value: 'OM', label: 'Oman' },
    { value: 'PK', label: 'Pakistan' },
    { value: 'PW', label: 'Palau' },
    { value: 'PS', label: 'Palestinian Territory, Occupied' },
    { value: 'PA', label: 'Panama' },
    { value: 'PG', label: 'Papua New Guinea' },
    { value: 'PY', label: 'Paraguay' },
    { value: 'PE', label: 'Peru' },
    { value: 'PH', label: 'Philippines' },
    { value: 'PN', label: 'Pitcairn' },
    { value: 'PL', label: 'Poland' },
    { value: 'PT', label: 'Portugal' },
    { value: 'PR', label: 'Puerto Rico' },
    { value: 'QA', label: 'Qatar' },
    { value: 'RE', label: 'Reunion' },
    { value: 'RO', label: 'Romania' },
    { value: 'RU', label: 'Russian Federation' },
    { value: 'RW', label: 'Rwanda' },
    { value: 'BL', label: 'Saint-Barthélemy' },
    { value: 'SH', label: 'Saint Helena' },
    { value: 'KN', label: 'Saint Kitts and Nevis' },
    { value: 'LC', label: 'Saint Lucia' },
    { value: 'MF', label: 'Saint-Martin' },
    { value: 'PM', label: 'Saint Pierre and Miquelon' },
    { value: 'VC', label: 'Saint Vincent and the Grenadines' },
    { value: 'WS', label: 'Samoa' },
    { value: 'SM', label: 'San Marino' },
    { value: 'ST', label: 'Sao Tome and Principe' },
    { value: 'SA', label: 'Saudi Arabia' },
    { value: 'SN', label: 'Senegal' },
    { value: 'RS', label: 'Serbia' },
    { value: 'CS', label: 'Serbia and Montenegro' },
    { value: 'SC', label: 'Seychelles' },
    { value: 'SL', label: 'Sierra Leone' },
    { value: 'SG', label: 'Singapore' },
    { value: 'SK', label: 'Slovakia' },
    { value: 'SI', label: 'Slovenia' },
    { value: 'SB', label: 'Solomon Islands' },
    { value: 'SO', label: 'Somalia' },
    { value: 'ZA', label: 'South Africa' },
    { value: 'GS', label: 'South Georgia and the South Sandwich Islands' },
    { value: 'SS', label: 'South Sudan' },
    { value: 'ES', label: 'Spain' },
    { value: 'LK', label: 'Sri Lanka' },
    { value: 'SD', label: 'Sudan' },
    { value: 'SR', label: 'Surilabel' },
    { value: 'SJ', label: 'Svalbard and Jan Mayen' },
    { value: 'SZ', label: 'Swaziland' },
    { value: 'SE', label: 'Sweden' },
    { value: 'CH', label: 'Switzerland' },
    { value: 'SY', label: 'Syrian Arab Republic' },
    { value: 'TW', label: 'Taiwan' },
    { value: 'TJ', label: 'Tajikistan' },
    { value: 'TZ', label: 'Tanzania, United Republic of' },
    { value: 'TH', label: 'Thailand' },
    { value: 'TL', label: 'Timor-Leste' },
    { value: 'TG', label: 'Togo' },
    { value: 'TK', label: 'Tokelau' },
    { value: 'TO', label: 'Tonga' },
    { value: 'TT', label: 'Trinidad and Tobago' },
    { value: 'TN', label: 'Tunisia' },
    { value: 'TR', label: 'Turkey' },
    { value: 'TM', label: 'Turkmenistan' },
    { value: 'TC', label: 'Turks and Caicos Islands' },
    { value: 'TV', label: 'Tuvalu' },
    { value: 'UG', label: 'Uganda' },
    { value: 'UA', label: 'Ukraine' },
    { value: 'AE', label: 'United Arab Emirates' },
    { value: 'GB', label: 'United Kingdom' },
    { value: 'US', label: 'United States' },
    { value: 'UM', label: 'United States Minor Outlying Islands' },
    { value: 'UY', label: 'Uruguay' },
    { value: 'UZ', label: 'Uzbekistan' },
    { value: 'VU', label: 'Vanuatu' },
    { value: 'VE', label: 'Venezuela' },
    { value: 'VN', label: 'Vietnam' },
    { value: 'VG', label: 'Virgin Islands, British' },
    { value: 'VI', label: 'Virgin Islands, U.S.' },
    { value: 'WF', label: 'Wallis and Futuna' },
    { value: 'EH', label: 'Western Sahara' },
    { value: 'YE', label: 'Yemen' },
    { value: 'ZM', label: 'Zambia' },
    { value: 'ZW', label: 'Zimbabwe' },
  ]

  vm.languages = [
    { value: 'af-ZA', label: 'Afrikaans' },
    { value: 'ar', label: 'Arabic' },
    { value: 'bg-BG', label: 'Bulgarian' },
    { value: 'ca-AD', label: 'Catalan' },
    { value: 'cs-CZ', label: 'Czech' },
    { value: 'cy-GB', label: 'Welsh' },
    { value: 'de-AT', label: 'German (Austria)' },
    { value: 'de-CH', label: 'German (Switzerland)' },
    { value: 'de-DE', label: 'German (Germany)' },
    { value: 'el-GR', label: 'Greek' },
    { value: 'en-GB', label: 'English (UK)' },
    { value: 'en-US', label: 'English (US)' },
    { value: 'es-CL', label: 'Spanish (Chile)' },
    { value: 'es-ES', label: 'Spanish (Spain)' },
    { value: 'es-MX', label: 'Spanish (Mexico)' },
    { value: 'es-EE', label: 'Spanish (Estonian)' },
    { value: 'eu', label: 'Basque' },
    { value: 'fa-IR', label: 'Persian' },
    { value: 'fi-FI', label: 'Finnish' },
    { value: 'fr-CA', label: 'French (Canada)' },
    { value: 'fr-FR', label: 'French (France)' },
    { value: 'he-IL', label: 'Hebrew' },
    { value: 'hr-HR', label: 'Croatian' },
    { value: 'hu-HU', label: 'Hungarian' },
    { value: 'id-ID', label: 'Indonesian' },
    { value: 'is-IS', label: 'Icelandic' },
    { value: 'it-IT', label: 'Italian' },
    { value: 'ja-JP', label: 'Japanese' },
    { value: 'km-KH', label: 'Khmer' },
    { value: 'ko-KR', label: 'Korean' },
    { value: 'la', label: 'Latin' },
    { value: 'lt-LT', label: 'Lithuanian' },
    { value: 'lv-LV', label: 'Latvian' },
    { value: 'mn-MN', label: 'Mongolian' },
    { value: 'nb-NO', label: 'Norwegian (Bokmål)' },
    { value: 'nl-NL', label: 'Dutch' },
    { value: 'nn-NO', label: 'Norwegian (Nynorsk)' },
    { value: 'pl-PL', label: 'Polish' },
    { value: 'pt-BR', label: 'Portuguese (Brazil)' },
    { value: 'pt-PT', label: 'Portuguese (Portugal)' },
    { value: 'ro-RO', label: 'Romanian' },
    { value: 'ru-RU', label: 'Russian' },
    { value: 'sk-SK', label: 'Slovak' },
    { value: 'sl-SI', label: 'Slovenian' },
    { value: 'sr-RS', label: 'Serbian' },
    { value: 'sv-SE', label: 'Swedish' },
    { value: 'th-TH', label: 'Thai' },
    { value: 'tr-TR', label: 'Turkish' },
    { value: 'uk-UA', label: 'Ukrainian' },
    { value: 'vi-VN', label: 'Vietnamese' },
    { value: 'zh-CN', label: 'Chinese (Simplified, PRC)' },
    { value: 'zh-SG', label: 'Chinese (Simplified, Singapore)' },
    { value: 'zh-SG', label: 'Chinese (Simplified, Singapore)' },
    { value: 'zh-TW', label: 'Chinese (Traditional, Taiwan)' },
    { value: 'zh-HK', label: 'Chinese (Traditional, Hong Kong S.A.R.)' },
    { value: 'zh-MO', label: 'Chinese (Traditional, Macao S.A.R.)' },
  ]

  vm.communities = [
    { value: 'JP', label: 'JP (Japanese)' },
    { value: 'KR', label: 'KR (Korean)' },
    { value: 'SC', label: 'SC (Simple Chinese)' },
    { value: 'TC', label: 'TC (Traditional Chinese)' },
  ]

  vm.removeAll = function () {
    vm.model.lcs = []
  }

  vm.removeAllLanguage = function () {
    vm.model.lang = []
  }

  vm.removeAllCommunities = function () {
    vm.model.comm = []
  }

  vm.closeModalChecklist = function () {
    $('#modalSegmentation').modal('hide')
  }

  vm.choose = function () {
    if (vm.orFlow) {
      if (vm.model.k == 8 || vm.model.k == 9 || vm.model.k == 10 || vm.model.k == 20) {
        vm.model.k = null
        swal("You cannot select this type when 'Create Or Segment' is enable", '', 'warning')
        return
      }
    }
  }

  vm.chooseOr = function () {
    if (vm.model.k == 8 || vm.model.k == 9 || vm.model.k == 10 || vm.model.k == 20) {
      vm.orFlow = false
      swal('You cannot enable when type already is a condition', '', 'warning')
      return
    }
  }
}
